import React from 'react';
import { useNavigate } from "react-router-dom";

import GooglePayButton from "@google-pay/button-react";

import "./Buttons.css";

const ButtonPay = () => {

    const navigateTo = useNavigate();

    return (
        <div className='row'>
            <div className='col-md-12'>
                <GooglePayButton
                    environment="TEST"
                    buttonColor="default"
                    buttonType="buy"
                    buttonRadius="4"
                    buttonSizeMode="fill"
                    style={{ left: 0, flex: 1, padding: 0, height: 40 }}
                    paymentRequest={{
                        apiVersion: 2,
                        apiVersionMinor: 0,
                        allowedPaymentMethods: [
                            {
                                type: 'CARD',
                                parameters: {
                                    allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                                    allowedCardNetworks: ["ELO", "ELO_DEBIT", "MAESTRO", "MASTERCARD", "VISA"],
                                },
                                tokenizationSpecification: {
                                    type: 'PAYMENT_GATEWAY',
                                    parameters: {
                                        gateway: 'example',
                                        gatewayMerchantId: 'exampleGatewayMerchantId',
                                    },
                                },
                            },
                        ],
                        merchantInfo: {
                            merchantId: '12345678901234567890',
                            merchantName: 'Demo Merchant',
                        },
                        transactionInfo: {
                            totalPriceStatus: 'FINAL',
                            totalPriceLabel: 'Total',
                            totalPrice: '1.00',
                            currencyCode: 'USD',
                            countryCode: 'US',
                        },
                    }}
                    onLoadPaymentData={paymentRequest => {
                        console.log('load payment data', paymentRequest);
                        navigateTo("/home?session=true");
                    }}
                />
            </div>
        </div>
    );
};

export default ButtonPay;